export const FRIEND_TRANSFER_TABLE_COL = [
  {
    displayName: "Name",
    key: ["name"],
  },
  {
    displayName: "Address",
    key: ["phone", "email"],
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Area",
    key: "area",
  },
  {
    displayName: "Zone",
    key: "zone",
  },
  {
    displayName: "Region",
    key: "region",
  },
  {
    displayName: "Chapter",
    key: "chapter",
  },
  {
    displayName: "District",
    key: "district",
  },
];

export const FRIEND_TRANSFER_REMARK_COL = [
  {
    displayName: "S.No.",
    key: "serialNumber",
  },
  {
    displayName: "Entered by",
    key: "serialNumber",
  },
  {
    displayName: "Remarks",
    key: "remarks",
  },
  {
    displayName: "Entered Date",
    key: "enteredDate",
  },
];

export const FRIEND_TRANSFER_TO = [
  {
    displayName: "Friend Name & Address",
    key: ["friendName", "address1"],
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Area",
    key: "area",
  },
  {
    displayName: "Zone",
    key: "zone",
  },
  {
    displayName: "Region",
    key: "region",
  },
  {
    displayName: "Chapter",
    key: "chapter",
  },
  {
    displayName: "District",
    key: "district",
  },
];
